export function getTenantUserId(user, tenantId) {
  const tenantUsers = user?.tenantUsers || [];

  const match = tenantUsers.find(
    (tu) => tu.tenantId === tenantId || tu.tenantID === tenantId
  );

  return (
    user?.tenantUser?.id ||
    match?.id ||
    user?.tenantUserId ||
    user?.tenantUserID ||
    null
  );
}